module.exports = __webpack_public_path__ + "img/doc.1791382d.png";